export const sessionTypeOptions = [
  { value: "Diagnostic", label: "Diagnostic" },
  { value: "Training", label: "Training" },
  { value: "Control", label: "Control" },
];